/**
 * The name of the record a record page shows (a customer's name, a locus code), for the breadcrumb's last part
 * (v7 Part E: Workspace / List / Record). The record page's <Page> publishes it; the top bar reads it.
 */
import { useSyncExternalStore } from 'react';

let current: { path: string; title: string } | null = null;
const listeners = new Set<() => void>();

export function publishRecordTitle(path: string, title: string | null) {
  const next = title ? { path, title } : null;
  if (current?.path === next?.path && current?.title === next?.title) return;
  current = next;
  listeners.forEach((l) => l());
}

export function useRecordTitle(path: string): string | null {
  const v = useSyncExternalStore((l) => { listeners.add(l); return () => { listeners.delete(l); }; }, () => current);
  return v && v.path === path ? v.title : null;
}
